import React, { useState } from 'react'
import moment from 'moment'

const withState = WrappedComponent => {
  return props => {
    const [liveNow, setLiveNow] = useState(null)
    const [pendingNow, setPendingNow] = useState(null)
    const [currentTime, setCurrentTime] = useState(moment())

    return (
      <WrappedComponent
        liveNow={liveNow}
        setLiveNow={setLiveNow}
        pendingNow={pendingNow}
        setPendingNow={setPendingNow}
        currentTime={currentTime}
        setCurrentTime={setCurrentTime}
        {...props}
      />
    )
  }
}

export default withState
